export default {
	title: "Fichas de Atención",
	cards: "Fichas de Atención",
	newCard: "Nueva Ficha",
	editCard: "Editar Ficha",
	deleteCard: "Eliminar Ficha",
	noCards: "Sin fichas configuradas",
	noCardsDescription: "Agregue fichas de atención para configurar los tipos de servicio de este ritual",
	form: {
		hasQueueLabel: "Tiene Cola",
		attendanceTypeLabel: "Tipo de Atención",
		attendanceTypeHint: "Seleccione el tipo de atención para vincular a este ritual",
		maxTicketsOverrideLabel: "Límite de Fichas (sobrescribir)",
		maxTicketsOverrideHint: "Deje vacío para usar el predeterminado del tipo de atención",
		defaultMaxTickets: "Predeterminado",
		typeInfo: "Configuración del tipo",
	},
	numberingModes: {
		INCREMENTAL: "Bajo demanda",
		PRE_DEFINED: "Fija",
		incrementalDescription: "Fichas agregadas de a una, bajo demanda",
		preDefinedDescription: "Muestra todas las fichas de 1 a N a la vez",
	},
	messages: {
		created: "Ficha de atención creada con éxito",
		updated: "Ficha de atención actualizada con éxito",
		deleted: "Ficha de atención eliminada con éxito",
		deleteError: "Error al eliminar ficha de atención",
		loadError: "Error al cargar fichas de atención",
		copied: "Fichas de atención importadas con éxito",
		copyError: "Error al importar fichas de atención",
	},
	deleteConfirmation: "¿Desea realmente eliminar la ficha {label}?",
	deleteWarning: "Esta acción no se puede deshacer.",
	copyFrom: "Importar Fichas",
	copyFromTitle: "Importar Estructura de Fichas",
	copyFromHint: "Seleccione un tipo de ritual para copiar sus vínculos de atención",
	copyFromPlaceholder: "Seleccione el tipo de ritual de origen",
	overridden: "Sobrescrito",
	validation: {
		maxTicketsMin: "La cantidad mínima es 1",
		attendanceTypeRequired: "El tipo de atención es obligatorio",
	},
};
